import { Types } from '~/store/modules/refreshToken/actions';

interface IAction {
  type: string;
  hash: string;
}

interface IRefreshTokenReturn {
  hash: string | null;
}

const INITIAL_STATE = {
  hash: null,
};

export default function refreshToken(
  state = INITIAL_STATE,
  action: IAction,
): IRefreshTokenReturn {
  switch (action.type) {
    case Types.SET:
      return {
        ...state,
        hash: action.hash,
      };
    default:
      return state;
  }
}
